<template>
    <div class="loading-container">
        <div class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</template>
<script>
export default {}
</script>

<style lang="scss">
@import "~ThemePath/scss/common/loading/index.scss";
</style>
